<template>
  <v-form class='viewPrefixForm' v-model='valid' ref='viewPrefixForm'>
    <v-container class='mb-10'>
      <v-row>
        <v-col cols="12" md="4" sm="6" xs="12">
          <label class='view_label'>Prefix : </label>
          <p>{{ prefix.prefix ? prefix.prefix : '-' }}</p>
        </v-col>
        <v-col cols="12" md="4" sm="6" xs="12">
          <label class='view_label'>Module : </label>
          <p>{{ prefix.module ? prefix.module : '-' }}</p>
        </v-col>
        <v-col cols="12" md="4" sm="6" xs="12">
          <label class='view_label'>Is Default : </label>
          <p>
            <template>
              <v-chip :color="this.prefix.is_default == 0 ? 'warning' : 'success'" small>{{ this.prefix.is_default == 0 ? 'No' : 'Yes' }}</v-chip>
            </template>
          </p>
        </v-col>
        <v-col cols="12" md="4" sm="6" xs="12">
          <label class='view_label'>Status : </label>
          <p>
            <template>
              <v-chip :color="this.prefix.status == 0 ? 'success' : 'warning'" small>{{ this.prefix.status == 0 ? 'Active' : 'Inactive' }}</v-chip>
            </template>
          </p>
        </v-col>
      </v-row>
      <v-footer fixed>
      <!--   <v-col class="text-right" v-if="$checkRight(['edit_prefix'])">
          <v-btn color="primary" class="mr-2" @click="changeDefaultStatus(prefix.id,true)" small v-if="!prefix.is_default">Make Default</v-btn>
          <v-btn color="primary" class="mr-2" @click="changeDefaultStatus(prefix.id,false)" small v-if="prefix.is_default">Remove Default</v-btn>
        </v-col> -->
      </v-footer>
    </v-container>
  </v-form>
</template>

<script>
export default {
  watch: {
    $route: function () {
      this.edit_id = this.$route.params.id
      this.reset()
    }
  },
  mounted () {
    const id = this.$route.params.id
    if (id) {
      this.$axios.post('getPrefixById/' + id).then((res) => {
        this.prefix = res.data.data
      }).catch(() => {
        this.loading = false
        console.log('some error occurred')
      })
    } else {
      this.edit_id = undefined
    }
  },
  data () {
    return {
      valid: false,
      edit_id: undefined,
      prefix: {},
      error: {}
    }
  },
  methods: {
    changeDefaultStatus (id, makeDefault) {
      const reqData = { module: this.prefix.module, isDefault: makeDefault }
      if (id) {
        this.$axios.post('changeDefaultStatus/' + id, reqData).then((res) => {
          this.prefix.is_default = res.data.is_default
        }).catch(() => {
          this.loading = false
          console.log('some error occurred')
        })
      } else {
        console.log('in else')
      }
    }
  }
}
</script>

<style>
.viewPrefixForm .radio-with-lable .v-input--selection-controls {
  margin-top: 0px;
}
.viewPrefixForm .c-radio-label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
}
.viewPrefixForm .view_label {
  font-size: 15px;
  font-weight: bold;
}
</style>
